
export const START_CALCULATION = "START_CALCULATION"

export const CHANGE_PAGE = "CHANGE_PAGE"

export const CALCULATION_SUCCESS= "CALCULATION_SUCCESS"

export const CALCULATION_FINISHED= "CALCULATION_FINISHED"

export const CALCULATION_FAILED ="CALCULATION_FAILED"

export const SEND_EVENT = "SEND_EVENT"

export const SEND_EVENT_SUCCESS = "SEND_EVENT_SUCCESS"

export const SEND_EVENT_ERROR = "SEND_EVENT_ERROR"

export const GET_EVENTS = "GET_EVENTS"

export const GET_EVENTS_SUCCESS = "GET_EVENTS_SUCCESS"

export const GET_EVENTS_ERROR = "GET_EVENTS_ERROR"

export const CURRENT_LOCATION = "CURRENT_LOCATION"

export const CURRENT_LOCATION_SUCCESS = "CURRENT_LOCATION_SUCCESS"

export const CURRENT_LOCATION_ERROR = "CURRENT_LOCATION_ERROR"
